import { render, staticRenderFns } from "./ConfirmMailPostJob.vue?vue&type=template&id=15fcb2d9&scoped=true&"
import script from "./ConfirmMailPostJob.vue?vue&type=script&lang=js&"
export * from "./ConfirmMailPostJob.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmMailPostJob.vue?vue&type=style&index=0&id=15fcb2d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fcb2d9",
  null
  
)

export default component.exports